<template>
  <v-dialog v-model="isOpened" :max-width="maxWidth">
    <template v-if="slots.activator" #activator="{ props: activatorProps }">
      <div v-bind="activatorProps">
        <slot name="activator" />
      </div>
    </template>
    <div class="alert-dialog__content">
      <div v-if="!title" class="h3 text-red mb-6">Ошибка</div>
      <div v-else class="h3 mb-6">{{ title }}</div>

      <slot />

      <div v-if="!hideCloseButton" class="alert-dialog__buttons">
        <e-btn variant="secondary" @click="closeDialog">Закрыть</e-btn>
      </div>

      <e-btn variant="ghost" icon size="S" class="alert-dialog__closer" @click="closeDialog">
        <e-icon name="closeSvg" />
      </e-btn>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { EBtn, EIcon } from '@/core/components/ui';

withDefaults(
  defineProps<{
    title?: string;
    hideCloseButton?: boolean;
    maxWidth?: string;
  }>(),
  {
    maxWidth: '880px',
  },
);

const slots = defineSlots<{
  default: (props: unknown) => void;
  activator?: (props: unknown) => void;
}>();

const isOpened = defineModel<boolean>({ required: true });

const closeDialog = () => {
  isOpened.value = false;
};
</script>

<style scoped lang="scss">
.alert-dialog {
  &__content {
    position: relative;

    padding: 40px;

    background-color: $main-bg-color;
    border-radius: $border-radius-xl;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;

    gap: 24px;

    margin-top: 40px;

    @include sm-and-down {
      gap: 8px;
    }
  }

  &__closer {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
